/**
 * 课程管理相关接口
 */
import request from '@/utils/request'

/**
 * 获取课程列表
 * @param params
 * @param { string } courses_name 课程名称
 * @param { number } courses_id 课程ID
 * @param { string } sec_category_id 二级课程分类
 * @param { string } category_id 一级课程分类
 * @param { string } page 页码
 * @param { string } page_size 每页数据量
 */
export function getCoursesList(params) {
	return request({
		url: '/admin/v1/courses/page_list',
		method: 'get',
		params
	})
}
/**
 * 获取课程详情
 * @param params
 * @param { number | require } id 课程id
 */
export function getCoursesDetail(params) {
	return request({
		url: '/admin/v1/courses/detail',
		method: 'get',
		params
	})
}
/**
 * 获取课程一、二级分类 枚举分类
 */
export function getDriverTrainingEnum(params) {
	return request({
		url: '/admin/v1/payload',
		method: 'get',
		params
	})
}
/**
 * 判断是否可编辑课程
 * @param params
 * @param { number | require } id 课程id
 */
export function getTrainsByCourseId(params) {
	return request({
		url: '/admin/v1/train/getTrainsByCourseId',
		method: 'get',
		params
	})
}
/**
 * 创建课程
 * @param params
 * @param { string | require } courses_name 课程名称
 * @param { number | require } category_id 一级分类ID
 * @param { number | require } sec_category_id 二级分类ID
 * @param { string | require } cover_url 封面图片地址
 * @param { string | require } small_cover_url 缩略图图片地址
 * @param { string } introduction 课程描述
 * @param { array | require } chapter_info 章节列表
 *  @param { string |require } chapter_name 章节名称
 *  @param { object | require } chapter_content 章节内容
 *  @param { string | require } data_type 章节类型，video=视频，audio=音频，doc=文档，link=链接，imageText=图文 ...
 *  @param { string | require} content 链接
 */
export function createCourses(params) {
	return request({
		url: '/admin/v1/courses/create',
		method: 'post',
		data: params
	})
}
/**
 * 更新课程
 * @param params
 * @param { string | require } courses_name 课程名称
 * @param { number | require } category_id 一级分类ID
 * @param { number | require } sec_category_id 二级分类ID
 * @param { string | require } cover_url 封面图片地址
 * @param { string | require } small_cover_url 缩略图图片地址
 * @param { string } introduction 课程描述
 * @param { array | require } chapter_info 章节列表
 *  @param { string |require } chapter_name 章节名称
 *  @param { object | require } chapter_content 章节内容
 *  @param { string | require } data_type 章节类型，video=视频，audio=音频，doc=文档，link=链接，imageText=图文 ...
 *  @param { string | require} content 链接
 */
export function updateCourses(params) {
	return request({
		url: '/admin/v1/courses/update',
		method: 'post',
		data: params
	})
}
/**
 *  培训相关资源上传
 *  @param { file | require } file_name 文件
 *  @param { string | require } category 资源分类  课程|章节｜培训: courses|chapter|train_task
 */
export function uploadDriverTrainingStaticSource(params) {
	return request({
		url: '/admin/v1/file/upload',
		method: 'post',
		data: params,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}
